import { Separator } from '@chakra-ui/react';

export const SeparatorHelper = () => {
  return (
    <Separator orientation="horizontal" borderColor="#A67C52" w="50px" mb={4} />
  );
};
